module.exports = __webpack_public_path__ + "static/img/privacypolicy.c2f4fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FFP/images/privacypolicy.png
// module id = UgnD
// module chunks = 0